/**
 * Brokerage endpoints (real backend `/v2/brokerages/` — formerly
 * `/v1/brokerage/`). Brokerages are the parent companies of brokers
 * (`/v2/brokers/`, see `agents.ts`).
 *
 * The autocomplete in the UW Information form lists brokerages from
 * here; selecting one autofills the submission's `brokerage_*` fields.
 */
import type { BrokerageCreateInput, BrokerageRow } from "../../types/submission";
import { getJsonReal, sendJsonReal } from "../client";

export interface ListBrokeragesParams {
    search?: string;
    limit?: number;
    offset?: number;
}

export function listBrokerages(params: ListBrokeragesParams = {}): Promise<BrokerageRow[]> {
    const qs = new URLSearchParams();
    if (params.search) qs.set("search", params.search);
    qs.set("limit", String(params.limit ?? 50));
    if (params.offset !== undefined) qs.set("offset", String(params.offset));
    return getJsonReal<BrokerageRow[]>(`/v2/brokerages/?${qs.toString()}`);
}

export function createBrokerage(input: BrokerageCreateInput): Promise<BrokerageRow> {
    return sendJsonReal<BrokerageRow>("/v2/brokerages/", "POST", input);
}

/** Compose a single-line brokerage address from the row's parts. The
 *  submission stores it flat. Empty parts are skipped so a partial
 *  brokerage doesn't leave dangling commas. */
export function formatBrokerageAddress(row: BrokerageRow): string {
    return [row.address, row.city, row.state, row.zip_code].filter((s) => s && s.trim() !== "").join(", ");
}
